"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../Button"));
const IconType_1 = __importDefault(require("../enums/IconType"));
const OverLay_1 = __importDefault(require("./OverLay"));
const ResetPasswordDone = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "popup-container" },
            react_1.default.createElement("section", { className: "popup" },
                react_1.default.createElement("div", { className: "popup__close" },
                    react_1.default.createElement(Button_1.default, { label: "", type: "tertiary", icon: IconType_1.default.Cancel, state: "enabled", handlerFunction: props.closeFunction })),
                react_1.default.createElement("div", { className: "popup__content reset-password-done-popup" },
                    react_1.default.createElement("h2", { className: "reset-password-done-popup__header" }, "New password set"),
                    react_1.default.createElement("p", { className: "reset-password-done-popup__text" }, "We have recorded the new password you set. With this you can already log in."),
                    react_1.default.createElement("div", { className: "reset-password-done-popup__close-button" },
                        react_1.default.createElement(Button_1.default, { label: "Login", type: "primary", icon: IconType_1.default.None, state: "enabled", handlerFunction: props.closeFunction }))))),
        react_1.default.createElement(OverLay_1.default, null)));
};
exports.default = ResetPasswordDone;
